const animationCss = `
    .animation-hidden {
        visibility: hidden!important;
        opacity: 0!important;
    }
`;

export { animationCss };
